export const STORAGE_KEYS = {
  AGENTS_ORDER: 'agents-order',
  LIVE_VIRTUAL_AGENTS: 'live-virtual-agents',
  COLD_MONITORING_FILTERS: 'cold-monitoring-filters',
  TABLE_STATE_COLD_MONITORING: 'table-state-cold-monitoring',
  TABLE_STATE_BUILD_VIRTUAL_AGENTS: 'table-state-build-virtual-agents',
  TABLE_STATE_ORGANIZATION_USERS: 'table-state-organization-users',
  SIDEBAR_OPEN_GROUPS: 'sidebar-open-groups',
  KNOWLEDGE: 'knowledge',
  LIST_CONFIGURATORS_FILTERS: 'list-configurators-filters',
  LIST_CONFIGURATORS_FILTERS_VERSION: 'list-configurators-filters-version',
  CONFIGURATOR_DRAFT: 'configurator-draft',
  MCP_SERVER_TOOLS: 'mcp_server_tools',
  TABLE_STATE_BUILD_VARIABLES: 'table-state-build-variables',
  VARIABLES_PAGE_SIZE: 'variables-page-size',
  KNOWLEDGE_PAGE_SIZE: 'knowledge-page-size',
  VIRTUAL_AGENTS_PAGE_SIZE: 'virtual-agents-page-size',
  VA_SHOW_ONLY_SELECTED_LANGUAGE: 'va-show-only-selected-language',
} as const
